import { Icon, Text, Tooltip } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

import { useDirectoryUser } from '~/client/hooks/storeHooks';

import { ExtraInfoContainer, UserEmail, UserName } from './DirectoryUserInfo.styled';

type Props = {
  className?: string;
  camdenAccountName: string;
};

export const DirectoryUserInfo: FunctionComponent<Props> = ({ className, camdenAccountName }) => {
  const directoryUser = useDirectoryUser(camdenAccountName);

  return (
    <>
      {!directoryUser && (
        <Text css={{ color: 'inherit' }} className={className}>
          {camdenAccountName}
        </Text>
      )}
      {directoryUser && (
        <Tooltip
          contentContainerProps={{ css: { maxWidth: 'unset' } }}
          content={
            <ExtraInfoContainer>
              <Text $weight={600}>{directoryUser.name}</Text>
              <Text>{directoryUser.department}</Text>
              <Text>{directoryUser.jobTitle}</Text>
              <UserEmail href={`mailto:${directoryUser.email}`}>
                <Icon $color="textSecondary" icon="ui/mail" />
                {directoryUser.email}
              </UserEmail>
            </ExtraInfoContainer>
          }
        >
          <UserName className={className} $color="primary" $weight={500}>
            {directoryUser.name}
          </UserName>
        </Tooltip>
      )}
    </>
  );
};
